import { useState, useEffect } from "react";
import DatesSubsection from "./DatesSubsection.jsx"; 
import ExpandSVG from "../../assets/ExpandSVG.jsx";

const MainDatesSection = ({ sectionsData, formData }) => {

    const [expandedSections, setExpandedSections] = useState({});
    const [filledFields, setFilledFields] = useState({}); 
    

    const toggleSection = (title) => {
        setExpandedSections((prev) => ({
            ...prev,
            [title]: !prev[title]
        }));
    };

    const handleFillField = (sectionTitle, isFilled) => {
        // console.log(`Updating filledFields for ${sectionTitle}: ${isFilled}`);
        setFilledFields((prevFilledFields) => ({
            ...prevFilledFields,
            [sectionTitle]: isFilled
        }));
    };

    const countFilledFields = (subSections) => {
        return subSections.reduce((count, subSection) => {
            const normalizedTitle = subSection.title.replaceAll(' ', '_').toLowerCase();
            if (filledFields[normalizedTitle]) {
                return count + 1;
            }
            return count;
        }, 0);
    };

    useEffect(() => {
        // Initialize filledFields state with data from formData
        const initialFilledFields = {};
        sectionsData.forEach(section => {
            section.subSections.forEach(subSection => {
                const normalizedTitle = subSection.title.replaceAll(' ', '_').toLowerCase();
                if (formData?.dateFields?.[normalizedTitle]?.date || formData?.dateFields?.[normalizedTitle]?.daysFromMEC) {
                    initialFilledFields[normalizedTitle] = true;
                }
            });
        });
        setFilledFields(initialFilledFields);
    }, [sectionsData, formData]);

    

    // console.log(formData);

    return (
        <div className="w-full">
            {sectionsData.map((section, index) => (
                <div key={index}>
                    <button 
                        className="w-full py-[2px] md:py-[7px] bg-shi-super-light-green text-black border-b overflow-hidden border-black justify-between items-center inline-flex hover:text-shi-purple"
                        onClick={() => toggleSection(section.title)}
                    >
                        <div className="grow h-[40px] md:h-[50px] px-[10px] md:px-[15px] py-2.5 justify-between items-center flex">
                            <span className="text-[14px] md:text-base font-normal font-['Inter']">{section.title}</span>
                            <div className="flex items-center gap-10 text-black">
                                <div className="text-sm text-left w-5">{countFilledFields(section.subSections)}/{section.subSections.length}</div>
                                <div className={`flex gap-[35px] transform ${expandedSections[section.title] ? 'rotate-180' : ''}`}>
                                    <ExpandSVG />
                                </div>
                            </div>
                        </div>
                    </button>
                    {expandedSections[section.title] && (
                        <div className="transition-all duration-300 ease-in-out" style={{ maxHeight: '2000px', overflowY: 'auto', height: 'auto' }}>
                            {section.subSections.map((subSection, subIndex) => {
                                const normalizedTitle = subSection.title.replaceAll(' ', '_').toLowerCase();
                                return (
                                    <DatesSubsection 
                                        key={subIndex} 
                                        subSection={subSection} 
                                        handleFillField={(isFilled) => handleFillField(normalizedTitle, isFilled)}
                                        filled={filledFields[normalizedTitle] || false}
                                        formData={formData}
                                    />
                                );
                            })}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
}

export default MainDatesSection;